export default {
      id: "nav_fleche_droite-usage",
      viewBox: "0 0 9 16",
      url: "../dist/images/" + "sprite.svg#nav_fleche_droite-usage",
      toString: function () {
        return this.url;
      }
    }